import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'conditionalSlice',
})
export class ConditionalSlicePipe implements PipeTransform {
  public transform(value: any[], start: number, end: number, dontSlice: boolean): any {
    if (!Array.isArray(value)) {
      return value;
    }
    if (dontSlice) {
      return value;
    }
    return value.slice(start, end);
  }
}
